// CSS required in the customer zone (equal in Finland and Sweden,
// although the angular app is instantiated only in the Finland version)
require('../css/style2.css');
require('./legacy-css/fileupload.css');
require('./legacy-css/nw-app.css');
require('./legacy-css/spinner.css');
import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngTranslate from 'angular-translate';
import 'angular-translate-loader-static-files';
import nwConstants from './nw-constants';
import { configureDebugFeatures } from './components/m-dbg';
import mwXbrowser from './components/xbrowser/xbrowser-directive';
import httpErrorInterceptor from './components/http-error-interceptor';
import nwUi from './components/nwui/0-nw-ui';
// angular application for customer zone
// this does pretty much nothing for the time being
// Adds the `jquery` to the global object under the names `$` and `jQuery`
import 'expose-loader?exposes=$,jQuery!jquery';
const app = angular.module('cz', [
    uiRouter,
    ngTranslate,
    mwXbrowser,
    nwConstants,
    httpErrorInterceptor,
    nwUi, // clicked-disable directive napin disablointiin painalluksen jälkeen
])
    .config(configure)
    .config(configureDebugFeatures);
export default app.name;
configure.$inject = ['$stateProvider', '$urlRouterProvider', '$translateProvider', 'Constants'];
function configure($stateProvider, $urlRouterProvider, $translateProvider, Constants) {
    // ei konffata edes routeria koska sitä ei käytetä tässä vaiheessa,
    // mutta oletettavasti tulee käyttöön joskus -> jätettiin copypastesta
    // dependencyt
}
